import { __assign } from 'tslib';
import { Extension } from '@tiptap/core';
import Blockquote from '@tiptap/extension-blockquote';
import Bold from '@tiptap/extension-bold';
import BulletList from '@tiptap/extension-bullet-list';
import Document from '@tiptap/extension-document';
import Dropcursor from '@tiptap/extension-dropcursor';
import Gapcursor from '@tiptap/extension-gapcursor';
import HardBreak from '@tiptap/extension-hard-break';
import Heading from '@tiptap/extension-heading';
import History from '@tiptap/extension-history';
import HorizontalRule from '@tiptap/extension-horizontal-rule';
import Italic from '@tiptap/extension-italic';
import Link from '@tiptap/extension-link';
import ListItem from '@tiptap/extension-list-item';
import OrderedList from '@tiptap/extension-ordered-list';
import Paragraph from '@tiptap/extension-paragraph';
import Placeholder from '@tiptap/extension-placeholder';
import Text from '@tiptap/extension-text';
import { Accessability } from './accessibility.js';

var editorStandardExtensions = Extension.create({
    name: "standardExtensions",
    addExtensions: function () {
        var extensions = [];
        if (this.options.accessibility !== false) {
            extensions.push(Accessability.configure(this.options.accessibility));
        }
        if (this.options.blockquote !== false) {
            extensions.push(Blockquote.configure(this.options.blockquote));
        }
        if (this.options.bold !== false) {
            extensions.push(Bold.configure(this.options.bold));
        }
        if (this.options.bulletList !== false) {
            extensions.push(BulletList.configure(this.options.bulletList));
        }
        if (this.options.document !== false) {
            extensions.push(Document.configure(this.options.document));
        }
        if (this.options.dropcursor !== false) {
            extensions.push(Dropcursor.configure(this.options.dropcursor));
        }
        if (this.options.gapcursor !== false) {
            extensions.push(Gapcursor.configure(this.options.gapcursor));
        }
        if (this.options.hardBreak !== false) {
            extensions.push(HardBreak.configure(this.options.hardBreak));
        }
        if (this.options.heading !== false) {
            extensions.push(Heading.configure(this.options.heading));
        }
        if (this.options.history !== false) {
            extensions.push(History.configure(this.options.history));
        }
        if (this.options.horizontalRule !== false) {
            extensions.push(HorizontalRule.configure(this.options.horizontalRule));
        }
        if (this.options.italic !== false) {
            extensions.push(Italic.configure(this.options.italic));
        }
        if (this.options.link !== false) {
            extensions.push(Link.configure(__assign({ openOnClick: false }, this.options.link)));
        }
        if (this.options.listItem !== false) {
            extensions.push(ListItem.configure(this.options.listItem));
        }
        if (this.options.orderedList !== false) {
            extensions.push(OrderedList.configure(this.options.orderedList));
        }
        if (this.options.paragraph !== false) {
            extensions.push(Paragraph.configure(this.options.paragraph));
        }
        if (this.options.placeholder !== false) {
            extensions.push(Placeholder.configure(this.options.placeholder));
        }
        if (this.options.text !== false) {
            extensions.push(Text.configure(this.options.text));
        }
        return extensions;
    },
});

export { editorStandardExtensions };
//# sourceMappingURL=editorStandardExtensions.js.map
